// Finnish texts. Typed as Strings, so a missing key or a function with different arguments is a compile error.
import type { Strings } from "./en.ts";

export const fi: Strings = {
  _name: "Suomi",
  _locale: "fi-FI",

  appName: "ReelHunt",
  appShort: "ReelHunt",
  viewLog: "Saaliit", viewMap: "Kartta", viewMore: "Asetukset",
  tabLog: "Saaliit", tabMap: "Kartta", tabAdd: "Saalis", tabMore: "Asetukset",
  all: "Kaikki", fishPl: "Kalat", gamePl: "Riista",
  fish: "Kala", game: "Riista",
  showFilter: "Näytä",

  // Log
  seasonFish: (n, yr) => `${n === 1 ? "kala" : "kalaa"} vuonna ${yr}`,
  seasonGame: (n, yr) => `${n === 1 ? "riistasaalis" : "riistasaalista"} vuonna ${yr}`,
  heaviest: "painavin",
  heaviestOf: (name) => `painavin: ${name}`,
  released: "Vapautettu",
  wxGetting: "Haetaan säätä…",
  wxOffline: "Sää lisätään, kun yhteys palaa",
  emptyTitle: "Kirjaa ensimmäinen saaliisi",
  emptyText: "Napauta ”Saalis” ja ota kuva. Paikka, aika ja sää tallentuvat automaattisesti.",
  emptyAdd: "Lisää saalis",
  emptyFilteredTitle: "Ei vielä merkintöjä",
  emptyFiltered: (kind) => kind === "fish" ? "Kaloja ei ole vielä kirjattu." : "Riistasaaliita ei ole vielä kirjattu.",

  // Map
  mapOffline: "Kartta tarvitsee nettiyhteyden, kun se avataan ensimmäisen kerran.",
  mapLocate: "Näytä sijaintini", mapFit: "Näytä kaikki saaliit", mapLayer: "Vaihda karttatyyppiä",
  mapTerrain: "Maastokartta", mapStreets: "Tiekartta",
  mapFull: "Kartta koko näytölle", mapExitFull: "Poistu koko näytöltä", mapExpand: "Suurenna kartta", done: "Valmis",
  mapHide: "Piilota painikkeet: näytä vain kartta", mapShow: "Näytä painikkeet",
  depthTitle: "Vesisyvyydet", depthDesc: "Syvyysalueet, -käyrät ja -luvut (Traficom, Syke)",
  mapDepth: "Näytä vesisyvyydet",
  depthOn: "Vesisyvyydet näkyvissä", depthOff: "Vesisyvyydet piilotettu",
  you: "Sinä",
  open: "Avaa",
  locationOff: "Sijainti ei ole käytössä. Salli sijainti tälle sivustolle selaimen asetuksista.",

  // Editor
  newCatch: "Uusi saalis", editCatch: "Muokkaa saalista",
  closeNoSave: "Sulje tallentamatta",
  photos: "Kuvat", takePhoto: "Ota kuva", addMorePhotos: "Lisää kuvia",
  removePhoto: "Poista kuva", photoAlt: "Saaliskuva",
  photoPreparing: "Valmistellaan kuvaa…",
  photoTime: "Aika otettiin kuvasta. Muuta sitä alla, jos se on väärin.",
  photoTimePlace: "Aika ja paikka otettiin kuvasta. Muuta niitä alla, jos ne ovat väärin.",
  photoBad: "Kuvaa ei voitu lukea. Kokeile toista kuvaa.",
  speciesLbl: "Laji", speciesFishPh: "esim. Hauki", speciesGamePh: "esim. Hirvi",
  weight: "Paino", length: "Pituus", when: "Aika", method: "Pyyntitapa",
  gearFish: "Viehe tai syötti", gearGame: "Ase ja patruuna",
  gearFishPh: "esim. Rapala Shad Rap 7 cm, firetiger", gearGamePh: "esim. Sako 85, .308 Win",
  releasedLong: "Vapautettu takaisin veteen",
  place: "Paikka",
  locRough: (d) => `Sijainti on epätarkka (±${d}). Tarkista, että ReelHunt saa käyttää tarkkaa sijaintia puhelimen asetuksissa (Sovellukset → ReelHunt → Sijainti → Käytä tarkkaa sijaintia).`,
  locFinding: "Haetaan sijaintia…",
  locUse: "Käytä sijaintiani",
  locNone: "Paikkaa ei ole merkitty. Merkitse paikka napauttamalla karttaa.",
  locGpsAcc: (m) => `Sijaintisi (±${m} m)`,
  locGps: "Sijaintisi", locPhoto: "Kuvasta", locMap: "Merkitty kartalle", locSaved: "Tallennettu paikka",
  locOff: "Sijainti ei ole käytössä. Merkitse paikka napauttamalla karttaa tai salli sijainti tälle sivustolle.",
  miniMapOffline: "Kartta ei toimi ilman yhteyttä. GPS-sijaintisi tallentuu silti.",
  placeFishPh: "Nimeä paikka, esim. Haukilahti, pohjoisranta", placeGamePh: "Nimeä paikka, esim. Passi 7, suon reuna",
  notes: "Muistiinpanot", notesFishPh: "Syvyys, veden lämpötila, mikä toimi, keitä oli mukana", notesGamePh: "Tuuli, mistä riista tuli, koira, keitä oli mukana",
  wxAuto: "Tämän paikan ja ajan sää tallentuu automaattisesti.",
  cancel: "Peruuta", saveCatch: "Tallenna saalis", saving: "Tallennetaan…",
  needSpecies: "Lisää ensin laji",
  saved: "Saalis tallennettu", changesSaved: "Muutokset tallennettu",
  storageFull: "Puhelimen tallennustila on täynnä. Vapauta tilaa ja yritä uudelleen.",
  saveFailed: "Tallennus ei onnistunut. Yritä uudelleen.",
  saveStuck: "Tallennus ei valmistunut. Sulje sovellus kokonaan, avaa se uudelleen ja tallenna vielä kerran.",
  speciesShowList: "Näytä lajilista", speciesRecent: "Viimeksi käytetyt", speciesAll: "Kaikki lajit",
  speciesNoMatch: "Ei listalla: tallentuu kirjoittamallasi nimellä.",

  // Detail
  close: "Sulje",
  wxHeading: "Sää saaliin hetkellä",
  wxNoSpot: "Paikkaa ei merkitty, joten säätä ei tallennettu. Muokkaa saalista ja merkitse paikka, niin sää lisätään.",
  wxPendingLong: "Haetaan säätä…",
  wxOfflineLong: "Sää lisätään, kun yhteys palaa.",
  weather: "Sää", wind: "Tuuli", gusts: (v) => `puuskat ${v}`,
  pressure: "Ilmanpaine", cloud: "Pilvisyys", rain: "Sade", humidity: "Ilmankosteus",
  moon: "Kuu", moonLit: (p) => `${p} % valaistu`,
  trend: { falling: "laskee", rising: "nousee", steady: "vakaa" },
  trend3h: (word, d) => `${word} (${d} / 3 h)`,
  spot: "Saalispaikka", directions: "Reittiohjeet paikalle",
  omaRiistaOpen: "Avaa Oma riista", omaRiistaHint: "Saalisilmoitus tehdään Oma riistassa. Jos sovellusta ei ole asennettu, pääset sen asennussivulle.",
  edit: "Muokkaa", del: "Poista", delConfirm: "Poista napauttamalla uudelleen",
  deleted: "Saalis poistettu", deleteFailed: "Poisto ei onnistunut. Yritä uudelleen.",

  // More
  langTitle: "Kieli",
  backupTitle: "Varmuuskopioi päiväkirja",
  backupText: "Saaliit ja kuvat on tallennettu vain tähän puhelimeen. Tallenna välillä varmuuskopio. Sen avulla voit myös siirtää päiväkirjan uuteen puhelimeen.",
  backupSave: "Tallenna varmuuskopio", backupRestore: "Palauta varmuuskopiosta",
  backupPreparing: "Valmistellaan varmuuskopiota…",
  backupShared: (n, p = 0) => `Varmuuskopio valmis: ${n} ${n === 1 ? "saalis" : "saalista"}, ${p} ${p === 1 ? "merkki" : "merkkiä"}.`,
  backupSaved: (name, n, p = 0) => `Tallennettu ${name}: ${n} ${n === 1 ? "saalis" : "saalista"}, ${p} ${p === 1 ? "merkki" : "merkkiä"}.`,
  backupFailed: "Varmuuskopion teko ei onnistunut. Yritä uudelleen.",
  backupShareTitle: "ReelHunt-varmuuskopio",
  restoring: "Palautetaan…",
  restored: (n) => `Palautettu ${n} saalista. Puhelimessa jo olleet saaliit säilyivät.`,
  restoreBad: "Tiedosto ei ole ReelHunt-varmuuskopio.",
  homeTitle: "Lisää aloitusnäytölle",
  homeText: "iPhonessa: napauta Jaa ja valitse ”Lisää Koti-valikkoon”. Androidissa: avaa selaimen valikko ja valitse ”Lisää aloitusnäytölle” tai ”Asenna sovellus”. Sovellus aukeaa silloin koko näytölle kuin tavallinen sovellus.",
  aboutTitle: "Tietoja",
  aboutText: "Sää haetaan Open-Meteo-palvelusta kunkin saaliin paikalle ja tunnille. Jos kenttää ei ole, saalis tallentuu ja sää lisätään, kun yhteys palaa. Kartat © OpenStreetMapin tekijät.",
  depthAbout: "Vesisyvyydet: Liikenne- ja viestintävirasto Traficomin merikarttatietokanta 10/2026, käytetty Traficomin merikartta-aineiston lisenssillä, sekä Suomen ympäristökeskuksen (Syke) järviluotaukset (CC BY 4.0). Syvyyskartta on kalareissujen suunnitteluun, ei navigointiin. Syvyystiedot voivat olla vanhentuneita.",
  storageInfo: (n, ph, mb) => `Tallennettu ${n} saalista ja ${ph} kuvaa` + (mb ? `, tilaa käytössä noin ${mb} Mt.` : "."),
  storageBlocked: "Tallennus on estetty tässä selaimessa, joten saaliita ei voi tallentaa.",

  // Water temperature
  waterTemp: "Veden lämpötila",
  waterPh: "Kirjoita oma lukemasi, tai jätä tyhjäksi, niin arvo haetaan lähimmältä järviasemalta tai meren ennustemallista.",
  waterAutoPh: (v, src) => `Automaattinen: ${v} °C (${src}). Kirjoita oma lukemasi korvataksesi sen.`,
  waterFetching: "Haetaan veden lämpötilaa…",
  waterNoneNear: "Lähistöltä ei löytynyt mitattua veden lämpötilaa. Kirjoita oma lukemasi, jos sinulla on.",
  waterManual: "oma mittaus", waterSea: "meri, ennustemalli",
  waterStation: (name, km) => `asema ${name}, ${km} km päässä`,
  waterChip: (v) => `vesi ${v}°C`,
  waterShort: "vesi", waterNowHint: (v, src) => `Vesi ${v} °C (${src}).`,
  mapStyles: "Kartan tyyli",
  mapTerrainDesc: "Maasto ja korkeuskäyrät (OpenTopoMap)",
  mapMmlDesc: "Tarkin Suomen kartta; voi tallentaa offline-käyttöön (Maanmittauslaitos)",
  mapStreetsDesc: "Tiet ja paikannimet (OpenStreetMap)",
  // Map tools
  mapPin: "Lisää merkki", mapDownload: "Tallenna alue offline-käyttöön", mapMml: "Maastokartta (MML)",
  placeHint: "Siirrä karttaa niin, että risti on paikan päällä", placeHere: "Merkitse tähän",
  pinNew: "Uusi merkki", pinEdit: "Muokkaa merkkiä", pinType: "Tyyppi", pinName: "Nimi", pinNamePh: "esim. Pohjoispassi, Haukilahti",
  pinNotesPh: "Syvyys, kulkureitti, kuka passia käyttää", pinPrivate: "Merkit ovat yksityisiä ja pysyvät tässä puhelimessa.",
  pinSave: "Tallenna merkki", pinSaved: "Merkki tallennettu", pinDeleted: "Merkki poistettu", directionsShort: "Reitti",
  pinTypes: { spot: "Kalapaikka", stand: "Passi", boat: "Veneranta", camera: "Riistakamera", parking: "Pysäköinti", other: "Muu" },
  route: "Reitti", routeLen: (km) => `${km} km`, routeDeleted: "Reitti poistettu", gpxSave: "Tallenna GPX:nä",
  windNow: "Tuuli nyt", windHint: "Nuoli näyttää, mihin tuuli puhaltaa. Hajusi kulkeutuu samaan suuntaan.",
  offlineTitle: "Offline-kartat",
  offlineText: "Tallenna kartta-alue paikkoihin, joissa ei ole kenttää: avaa kartta, näytä tarvitsemasi alue ja napauta latauspainiketta. Maastokartta ja vesisyvyydet tallennetaan.",
  offlineNeedKey: "Offline-kartat käyttävät Maanmittauslaitoksen maastokarttaa, joka tarvitsee ilmaisen API-avaimen. Sitä ei ole vielä asetettu.",
  offlineUnsupported: "Tämä selain ei voi tallentaa karttoja offline-käyttöön.",
  offlineTooBig: "Alue on liian suuri tallennettavaksi. Lähennä karttaa vähän ja yritä uudelleen.",
  offlineAsk: (n, mb) => `Tallennetaanko näkyvä alue käytettäväksi ilman kenttää? Enintään noin ${mb} Mt (${n} karttaruutua).`,
  download: "Lataa", ok: "OK",
  offlineProgress: (a, b) => `Tallennetaan karttaa… ${a} / ${b}`,
  offlineDone: "Alue tallennettu. Se toimii nyt ilman kenttää.",
  offlineFailed: (n) => `${n} karttaruutua ei voitu tallentaa. Yritä uudelleen paremmalla yhteydellä.`,
  offlineInfo: (n, mb) => `Tallennettu ${n} karttaruutua, enintään noin ${mb} Mt.`,
  offlineNone: "Kartta-alueita ei ole vielä tallennettu.",
  offlineClear: "Poista tallennetut kartat", offlineCleared: "Tallennetut kartat poistettu",
  placesTitle: "Reitit ja paikat (GPX)",
  placesText: "Tuo reittejä, reittipisteitä ja passeja GPX-, KML- tai KMZ-tiedostoina Garminista, onX:stä, HuntStandista, Google Earthista tai muista GPS-sovelluksista (vie ne ensin toisesta sovelluksesta, usein sen verkkosivulla). Passit, riistakamerat ja pysäköintipaikat tunnistetaan nimestä ja symbolista. Vie merkkisi, reittisi ja saalispaikkasi Garmin-laitteeseen tai toiseen sovellukseen.",
  placesInfo: (p, r) => `Puhelimessa ${p} ${p === 1 ? "merkki" : "merkkiä"} ja ${r} ${r === 1 ? "reitti" : "reittiä"}.`,
  gpxImport: "Tuo GPX / KML", gpxExport: "Vie GPX", gpxTitle: "Reitit ja paikat",
  gpxImported: (p, r) => `Tuotu ${p} ${p === 1 ? "reittipiste" : "reittipistettä"} ja ${r} ${r === 1 ? "reitti" : "reittiä"}.`,
  gpxSomeBad: (n) => n === 1 ? "Yhtä tiedostoa ei voitu lukea." : `${n} tiedostoa ei voitu lukea.`,
  gpxBad: "Reittejä tai paikkoja ei löytynyt. Valitse GPX-, KML- tai KMZ-tiedosto.",
  gpxExported: (p, r, c) => `Viety ${p} ${p === 1 ? "merkki" : "merkkiä"}, ${r} ${r === 1 ? "reitti" : "reittiä"} ja ${c} ${c === 1 ? "saalispaikka" : "saalispaikkaa"}.`,
  gpxNothing: "Ei vielä mitään vietävää. Lisää merkkejä, tuo reittejä tai kirjaa saaliita ensin.",
  gpxFailed: "GPX-tiedoston teko ei onnistunut. Yritä uudelleen.",

  // Groups
  viewGroups: "Porukat", tabGroups: "Porukat",
  groupsIntro: "Yksityiset porukat kalakavereille ja metsästysseurueelle. Viestit, kuvat ja paikat salataan puhelimessasi; palvelin välittää vain sekoitettua dataa eikä pysty lukemaan sitä.",
  groupYou: "Näyt nimellä", groupNoName: "(ei vielä nimeä)", change: "Vaihda",
  groupNew: "Uusi porukka", groupJoinLink: "Liity linkillä", groupInvite: "Kutsu",
  groupsEmptyTitle: "Ei vielä porukoita", groupsEmptyText: "Luo porukka ja lähetä kutsulinkki kaverille, tai avaa saamasi kutsulinkki. Kaveri on vain kahden hengen porukka.",
  groupNoMessages: "Ei vielä viestejä", groupBroken: "Tämän porukan linkki ei enää toimi", groupUnnamed: "Porukka", groupSomeone: "Joku",
  groupName: "Porukan nimi", groupNamePh: "esim. Haukiporukka, Hirviseurue", groupNeedGroupName: "Anna porukalle nimi",
  groupYourName: "Nimesi porukoissa", groupYourNamePh: "esim. Paul", groupNeedName: "Lisää nimi, jonka muut näkevät",
  groupNameHint: "Tämä nimi näkyy viestiesi yhteydessä kaikissa porukoissa.",
  groupNewHint: "Seuraavaksi saat kutsulinkin, jonka lähetät muille.", groupCreate: "Luo porukka",
  groupOffline: "Ei yhteyttä palvelimeen. Tarkista nettiyhteys ja yritä uudelleen.",
  groupInviteTitle: (n) => `Kutsu porukkaan ${n}`,
  groupInviteText: "Lähetä tämä linkki niille, jotka haluat porukkaan, tai anna heidän skannata koodi puhelimen kameralla.",
  groupInviteWarn: "Kuka tahansa, jolla on linkki, voi liittyä ja lukea porukan viestit, joten jaa se vain luotetuille ihmisille.",
  groupInviteShareTitle: (n) => `Liity porukkaan ${n}`, groupInviteShareText: (n) => `Liity porukkaani ${n} ReelHuntissa:`,
  copyLink: "Kopioi linkki", copied: "Kopioitu", shareLink: "Jaa linkki",
  groupJoinTitle: "Liity porukkaan", groupJoinText: "Sinut on kutsuttu. Nimesi näkyy porukalle viestiesi yhteydessä.", groupJoin: "Liity",
  groupPasteLbl: "Kutsulinkki", groupPastePh: "Liitä saamasi linkki", groupBadLink: "Tämä ei ole porukan kutsulinkki.", next: "Seuraava",
  groupChangeName: "Nimesi", save: "Tallenna",
  groupMembersSeen: (n) => n === 1 ? "1 jäsen toistaiseksi" : `${n} jäsentä`,
  groupLeave: "Poistu porukasta", groupLeaveConfirm: "Poistu napauttamalla uudelleen", groupLeft: "Poistuit porukasta. Sen viestit poistettiin tästä puhelimesta.",
  chatEmpty: "Ei vielä viestejä. Sano hei tai jaa saalis.", chatPh: "Viesti", chatSend: "Lähetä",
  chatPrivacy: "Salattu · palvelimella enintään 30 päivää",
  msgPhoto: "Kuva", msgCatch: (s) => `Saalis: ${s}`, msgPin: (n) => `Paikka: ${n}`, msgJoined: (n) => `${n} liittyi`, msgYou: "Sinä",
  msgSpotHidden: "Paikkaa ei jaettu", msgShowMap: "Näytä kartalla", msgSavePin: "Tallenna kartalleni", msgSaved: "Tallennettu",
  msgNotSent: "Ei lähetetty. Tarkista yhteys ja yritä uudelleen.", msgTooBig: "Liian suuri lähetettäväksi. Kokeile pienempää kuvaa.",
  share: "Jaa", shareTo: "Lähetä porukkaan", shareChoose: "Valitse ensin porukka", shareSend: "Lähetä", shareSent: (n) => `Lähetetty porukkaan ${n}`,
  shareNoGroups: "Luo porukka tai liity porukkaan ensin (Porukat-välilehti).",
  shareCatchTitle: "Jaa saalis", shareSpot: "Jaa myös tarkka paikka",
  shareSpotHint: "Oletuksena pois päältä, joten paikkasi pysyy salaisena. Kuva, koko, aika ja sää lähetetään aina.",
  sharePinTitle: "Jaa paikka", sharePinHint: "Porukka näkee merkin nimen, tyypin, muistiinpanot ja tarkan sijainnin.",

  // Profile and tips
  profileTitle: "Kalastuksesi ja metsästyksesi",
  profileMoreText: "Kerro, miten yleensä kalastat ja metsästät, niin sovellus ehdottaa sääennusteen perusteella hyviä päiviä ja öitä.",
  profileIntro: "Valitse kaikki sopivat. Saaliit-välilehden vinkit perustuvat näihin ja kahden seuraavan päivän sääennusteeseen.",
  profileEdit: "Muokkaa", profileSaved: "Tallennettu. Vinkit päivitetty.", profileEmpty: "Ei vielä valintoja.",
  profileFishLine: (x) => `Kalastus: ${x}`, profileHuntLine: (x) => `Metsästys: ${x}`,
  pfFishHow: "Miten kalastat?", pfFishWhat: "Mitä kalastat?", pfHuntHow: "Miten metsästät?", pfHuntWhat: "Mitä metsästät?",
  huntStyles: { stand: "Passi- tai kyttäysmetsästys", dog: "Koiran kanssa", stalk: "Hiipiminen", drive: "Ajojahti", waterfowl: "Vesilinnut", bow: "Jousimetsästys", trapping: "Loukkupyynti" },
  tipsHome: "Alue ennustetta varten", tipsHomeSet: (a, b) => `Valitsemasi alue (${a}, ${b}).`,
  tipsHomeNone: "Ei asetettu: käytetään viimeisimmän saaliin paikkaa.", tipsHomeClear: "Käytä viimeisintä saalista",
  tipsTitle: "Vinkit kahdelle päivälle", tipsEdit: "Muuta",
  tipsSetupTitle: "Saa vinkkejä hyvästä kalastus- ja metsästyssäästä",
  tipsSetupText: "Kerro, miten kalastat ja metsästät, esim. verkoilla tai passissa.", tipsSetupBtn: "Aloita",
  tipsNoPlace: "Valitse alue ennustetta varten, tai kirjaa saalis paikan kanssa.", tipsSetPlace: "Valitse alue",
  tipsLoading: "Haetaan ennustetta…", tipsOffline: "Vinkit tarvitsevat nettiyhteyden.",
  tipsNone: "Kahden seuraavan päivän aikana ei ole erityisiä olosuhteita sinun tapaasi kalastaa ja metsästää.",
  tipsForHome: "Ennuste valitsemallesi alueelle (Open-Meteo).", tipsForCatch: "Ennuste viimeisimmän saaliisi paikalle (Open-Meteo).",
  when_night_0: "tänä yönä", when_night_1: "huomisyönä",
  when_evening_0: "tänä iltana", when_evening_1: "huomisiltana",
  when_morning_0: "tänä aamuna", when_morning_1: "huomisaamuna", when_morning_2: "ylihuomisaamuna",
  when_day_0: "tänään", when_day_1: "huomenna",
  tipNetCalmTitle: (w) => `Tyyntä ${w}: hyvä verkoille`,
  tipNetCalmText: (w, g) => `Tuulta yön aikana enintään ${w} m/s (puuskat ${g}). Hyvä yö laskea verkot tai pitkäsiimat.`,
  tipNetWindTitle: (w) => `Kova tuuli ${w}`,
  tipNetWindText: (w, g) => `Tuulta jopa ${w} m/s, puuskat ${g}. Verkot voivat ajautua tai sotkeutua; harkitse niiden nostamista.`,
  tipFlyTitle: (w) => `Tyyntä ${w} perhokalastukseen`,
  tipFlyText: (w) => `Tuulta enintään ${w} m/s eikä sadetta. Hyvä heittää ja nähdä kalojen nousut.`,
  tipPressureTitle: "Ilmanpaine laskee",
  tipPressureText: (d, when) => `Laskee ${d} hPa kuudessa tunnissa alkaen ${when}. Moni kalastaja huomaa petokalojen syövän aktiivisesti paineen laskiessa.`,
  tipStandTitle: (w, dir) => `Tasainen ${dir} ${w}`,
  tipStandText: (from, to, w) => `Tuuli puhaltaa ${from} (enintään ${w} m/s), joten hajusi kulkeutuu ${to}. Valitse passi, johon riista tulee tuulen yläpuolelta.`,
  tipDogTitle: (w) => `Hyvä koirakeli ${w}`,
  tipDogText: (w) => `Poutaa ja tuulta enintään ${w} m/s. Hyvät olosuhteet koiran työskentelyyn ja haukun kuulemiseen.`,
  tipSnowTitle: (w) => `Uutta lunta jäljestykseen ${w}`,
  tipSnowText: (cm) => `Yöllä noin ${cm} cm uutta lunta, sitten sade lakkaa. Tuoreet jäljet on helppo lukea.`,

  // Notifications
  pushTitle: "Ilmoitukset",
  pushMsgs: "Uudet viestit porukoissa", pushMsgsText: "Kuka kirjoitti mitä, purettuna puhelimessasi.",
  pushMsgsTextNative: "Ilmoitus, kun porukassa on uusia viestejä (ne pysyvät salattuina: avaa porukka lukeaksesi).",
  pushTips: "Iltaiset säävinkit", pushTipsText: "Noin klo 18, vain kun sinun tapaasi kalastaa ja metsästää on vinkki.",
  pushPrivacy: "Porukkailmoituksissa ei ole viestin tekstiä; puhelimesi hakee ja purkaa viestin itse. Säävinkkejä varten palvelin säilyttää karkean alueesi (noin 10 km) ja kalastus- ja metsästysvalintasi ilman nimeä.",
  pushMsgsOn: "Ilmoitukset porukkaviesteistä päällä", pushTipsOn: "Iltaiset säävinkit päällä",
  pushNeedHome: "iPhonessa ilmoitukset toimivat, kun ReelHunt on lisätty Koti-valikkoon (Jaa → Lisää Koti-valikkoon). Avaa se sieltä.",
  pushUnsupported: "Tämä selain ei pysty näyttämään ilmoituksia.",
  pushBlocked: "Ilmoitukset on estetty ReelHuntilta. Salli ne puhelimen asetuksista tälle sivustolle tai sovellukselle.",
  pushDenied: "Ilmoituksia ei sallittu.", pushNeedProfile: "Kerro ensin, miten kalastat ja metsästät.",
  pushFailed: "Ei onnistunut. Tarkista yhteys ja yritä uudelleen.",
  // Learning from your catches
  learnTitle: "Parhaat olosuhteesi",
  learnSpecies: (name, n) => `${name} · ${n} saalista`,
  learnTime: (a, b) => `klo ${a}–${b}`, learnWind: (w) => `tuuli ≤ ${w} m/s`,
  learnTrend_falling: "paine laskee", learnTrend_rising: "paine nousee", learnTrend_steady: "paine vakaa",
  learnTimeLong: (a, b, p) => `Useimmat saaliit klo ${a}–${b} (${p} %)`,
  learnWindLong: (w) => `Tuuli yleensä enintään ${w} m/s`,
  learnTrendLong_falling: (p) => `Ilmanpaine laskee (${p} % saaliista)`,
  learnTrendLong_rising: (p) => `Ilmanpaine nousee (${p} % saaliista)`,
  learnTrendLong_steady: (p) => `Ilmanpaine vakaa (${p} % saaliista)`,
  learnWater: (a, b) => `Vesi yleensä ${a}–${b} °C`, learnMoon: (m) => `Usein kuun vaiheessa: ${m}`,
  learnFoot: "Omista saaliistasi, joihin sää on tallentunut. Kun tuleva sää täsmää, saat vinkin.",
  learnNotYet: (min, n) => `Kun samaa lajia on ${min} saalista, ReelHunt näyttää olosuhteet, joissa saat sitä (nyt ${n}).`,
  tipLearnedTitle: (name) => `Sinun ${name.toLowerCase()}kelisi`,
  tipLearnedText: (n, when, summary) => `Alkaen ${when} sää vastaa ${n} aiempaa saalistasi: ${summary}.`,

  // Keeping your data safe
  snapTitle: "Automaattiset kopiot tässä puhelimessa",
  snapText: "Sovellus ottaa joka päivä kopion merkeistäsi, reiteistäsi ja saaliistasi (7 viimeisintä) sekä aina ennen tuontia tai palautusta. Palautus tuo takaisin puuttuvat eikä koskaan poista uudempia. Kuvat eivät ole mukana kopioissa.",
  snapNone: "Ei vielä kopioita. Ensimmäinen otetaan tänään, kun sinulla on merkkejä tai saaliita.",
  snapRestore: "Palauta", snapConfirm: "Palauta napauttamalla uudelleen",
  snapCounts: (p, r, c) => `${p} ${p === 1 ? "merkki" : "merkkiä"} · ${r} ${r === 1 ? "reitti" : "reittiä"} · ${c} ${c === 1 ? "saalis" : "saalista"}`,
  snapReason_import: "ennen tuontia", snapReason_restore: "ennen palautusta",
  snapRestored: (n) => `Palautettiin ${n} kohdetta.`, snapNothing: "Mitään ei puuttunut; kaikki kopion sisältö on yhä tallessa.",
  agoToday: "tänään", agoYesterday: "eilen", agoDays: (n) => `${n} päivää sitten`,
  backupLast: (a) => `Viimeisin varmuuskopio: ${a}.`, backupNever: "Varmuuskopiota ei ole vielä tehty.",
  storageProtected: "Tämä puhelin suojaa sovelluksen tiedot automaattiselta tyhjennykseltä.",
  storageNotProtected: "Selain voi tyhjentää sovelluksen tiedot, jos puhelimen tila loppuu. Lisää ReelHunt aloitusnäytölle ja tee välillä varmuuskopio.",
  nudgeTitle: "Varmuuskopioi passit ja saaliit",
  nudgeText: (a, n) => `Viimeisin varmuuskopio ${a}. Sinulla on ${n} merkkiä ja saalista vain tässä puhelimessa.`,
  nudgeTextNever: (n) => `Sinulla on ${n} merkkiä ja saalista vain tässä puhelimessa. Yksi napautus tallentaa varmuuskopion.`,
  nudgeNow: "Varmuuskopioi", nudgeLater: "Myöhemmin",
  gpxDuplicates: (n) => n === 1 ? "1 oli jo tallessa ja ohitettiin." : `${n} oli jo tallessa ja ohitettiin.`,
  gpxAllDuplicates: (n) => `Kaikki tiedoston kohteet (${n}) ovat jo tallessa.`,
  windSource: (age) => `Open-Meteo · ${age}`, windJustNow: "juuri päivitetty", windMinutes: (n) => `${n} min sitten`,
  windSourceLong: (time) => `Tuulitieto Open-Meteosta, päivitetty klo ${time}; päivittyy 10 minuutin välein, kun kartta on auki.`,

  // Club stand board
  clubShort: "Passit", clubOpen: "Seuran passitaulu", clubTitle: (n) => `Passit · ${n}`,
  clubSummary: (taken, all) => `${taken}/${all} passia varattu`,
  clubEmpty: "Seuralla ei vielä ole passeja. Lisää omat passimerkkisi tai uusi passi kartan keskelle.",
  clubFree: "Vapaa", clubMine: "Sinun passisi", clubTakenBy: (n) => `Varannut: ${n}`,
  clubReserve: "Varaa", clubCancel: "Peru", clubFreeIt: "Vapauta", clubConfirm: "Napauta uudelleen", clubStand: "Passi",
  clubRemove: (n) => `Poista ${n} seuran kartalta`,
  clubLost: (n) => `${n} ehti varata passin juuri ennen sinua.`,
  clubAddStands: "Lisää passeja", clubFromPins: "Omat passimerkkisi", clubAddChosen: "Lisää valitut",
  clubNoOwnStands: "Sinulla ei ole vielä omia passimerkkejä.", clubAtCenter: "Uusi passi kartan ristin kohdalle",
  clubNamePh: "Nimi, esim. Passi 7", clubAdd: "Lisää",
  clubPrivacy: "Taulu näkyy vain tälle porukalle ja on salattu kuten viestit. Jos kaksi varaa saman passin yhtä aikaa, ensimmäinen saa sen.",
  drawBtn: "Passiarvonta", drawWho: (n) => `Ketkä ovat metsällä? Heidät arvotaan ${n} vapaalle passille.`, drawGo: "Arvo passit",
  drawNothing: "Tälle päivälle ei ole vapaita passeja tai arvottavia metsästäjiä.", drawTooFew: (n) => `Vain ${n} passia oli vapaana; loput jäivät ilman passia.`, drawDone: "Passit arvottu.",
  evStandAdded: (who, s) => `${who} lisäsi passin ${s}`, evStandRemoved: (who) => `${who} poisti passin`,
  evAreaSet: (who) => `${who} lisäsi seuran alueen Oma riistasta`, evAreaRemoved: (who) => `${who} poisti seuran alueen`,
  areaAdd: "Näytä seuran alue Oma riistasta", areaTitle: "Seuran alue", areaChange: "Vaihda", areaLoading: "Haetaan seuran aluetta Oma riistasta…",
  areaSignIn: "Kirjaudu sisään, niin näet seuran alueen Oma riistasta (Oma riista haluaa tietää, kuka tietoja hakee).",
  areaNotFound: (id) => `Oma riistassa ei ole aluetta tunnuksella ${id}.`, areaOffline: "Ei yhteyttä: seuran aluetta ei voi nyt hakea.",
  areaUnavailable: "Oma riistaan ei juuri nyt saada yhteyttä. Yritä myöhemmin uudelleen.", areaYear: (a, b) => `metsästysvuosi ${a}–${b}`,
  areaImport: (n) => `Lisää passit Oma riistasta (${n})`, areaImported: (n) => `${n} passia lisätty Oma riistasta`,
  areaIdLbl: "Oma riistan alueen tunnus", areaSave: "Näytä", areaRemove: "Poista seuran alue", areaBadId: "Alueen tunnuksessa on vähintään 10 kirjainta ja numeroa.",
  areaIdHint: "Löydät sen Oma riistasta seuran metsästysalueen tiedoista (Alueen tunnus). Sen jälkeen kaikki ryhmän jäsenet näkevät alueen ja sen passit tällä kartalla.",
  poiStand: "Passi", poiFeeding: "Ruokintapaikka", poiLick: "Nuolukivi", poiOther: "Paikka",
  evReserved: (who, s, d) => `${who} varasi passin ${s} (${d})`, evDrawn: (who, s, d) => `Passiarvonta: ${who} sai passin ${s} (${d})`,
  evCancelled: (who, s, d) => `${s} vapautui (${d}, ${who})`,

  // Photo feed
  chatTabChat: "Keskustelu", chatTabFeed: "Kuvat",
  feedNew: "Uusi kuva", feedEmpty: "Ei vielä kuvia. Julkaise kuva tai jaa saalis: se näkyy täällä korttina, josta porukka voi tykätä ja jota voi kommentoida.",
  feedOpen: "Avaa kuva", feedComment: "Kommentoi", feedLike: "Tykkää", feedUnlike: "Poista tykkäys",
  feedAllComments: (n) => `Näytä kaikki ${n} kommenttia`, feedLikedBy: (names) => `Tykkäsi: ${names}`,
  feedComments: (n) => n === 1 ? "1 kommentti" : `${n} kommenttia`, feedNoComments: "Ei vielä kommentteja",
  feedCommentPh: "Kirjoita kommentti", feedCaption: "Kuvateksti", feedCaptionPh: "Mitä kuvassa tapahtuu?",
  msgComment: (text) => `kommentoi: ${text}`,

  // Season presentation
  seasonBtn: "Kauden kooste", seasonOwnBtn: "Oma kausi", seasonOwnTitle: "Oma kausi",
  seasonPick: "Kauden kooste", seasonPickText: "Valitse kausi. Kooste toistuu koko näytöllä: napauta oikealle eteenpäin, vasemmalle taaksepäin, pidä pohjassa tauottaaksesi. Yhdessä katsomiseen näytä se televisiosta näytön peilauksella.",
  seasonLast12: "Viimeiset 12 kk", seasonEmpty: "Ei vielä näytettävää: julkaise kuvia tai jaa saaliita ensin.",
  seasonKicker: "Kauden kooste", seasonOf: (y) => `Kausi ${y}`,
  seasonNumbers: "Kausi numeroina", seasonCatches: "saalista", seasonSpecies: "lajia", seasonWeight: "kalaa yhteensä", seasonPhotos: "kuvaa", seasonPeople: "metsästäjää ja kalastajaa",
  seasonBiggest: "Kauden suurin kala", seasonBiggestGame: "Kauden suurin riista", seasonTopSpecies: "Eniten saatu", seasonMostLiked: "Tykätyin kuva", seasonLikes: (n) => n === 1 ? "1 tykkäys" : `${n} tykkäystä`,
  seasonMonths: "Saaliit kuukausittain", seasonBestMonth: (m, n) => `Paras kuukausi: ${m} (${n})`,
  seasonPeopleTitle: "Kuka sai mitä", seasonThanks: "Kiitos kaudesta!", seasonEndLine: (c, p) => `${c} saalista · ${p} kuvaa. Nähdään ensi kaudella.`,

  themeTitle: "Teema", theme_auto: "Automaattinen", theme_light: "Vaalea", theme_dark: "Tumma",
  privacyLink: "Tietosuojaseloste",
  // Palaute
  feedbackTitle: "Palaute",
  feedbackPanel: "Jokin ei toimi, tai sinulla on idea? Kerro meille: jokainen viesti luetaan.",
  feedbackOpen: "Lähetä palautetta",
  guideLink: "Aloitusopas",
  feedbackIntro: "Mitä tapahtui, tai mikä tekisi ReelHuntista sinulle paremman?",
  feedbackText: "Viestisi",
  feedbackTextPh: "esim. kartta jumittui, kun…",
  feedbackEmail: "Sähköposti vastausta varten (vapaaehtoinen)",
  feedbackSent: (v) => `Mukaan lähtevät sovelluksen versio (${v}), laitetyyppi, kieli ja näytön koko. Ei paikkoja, saaliita eikä porukoiden tietoja.`,
  feedbackSend: "Lähetä",
  feedbackThanks: "Kiitos! Palautteesi lähti.",
  feedbackFailed: "Lähetys ei onnistunut. Tarkista yhteys ja yritä uudelleen.",
  appVersion: (v) => `Versio ${v}`,

  // Reissu
  tripStart: "Aloita reissu",
  tripWhat: "Mitä olet hakemassa?",
  tripAnything: "Mitä vain",
  tripSpeciesPh: "Laji (vapaaehtoinen)",
  tripRouteNote: "Reitti tallentuu, kun ReelHunt on auki näytöllä. Pitkällä reissulla laita päälle “Pidä näyttö päällä”.",
  tripRouteNoteNative: "Reitti tallentuu myös näytön ollessa pimeänä. Reissun aikana näkyy ilmoitus; lopeta reissu, niin tallennus loppuu.",
  tripRecordingTitle: "ReelHunt tallentaa reissuasi",
  tripRecordingText: "Reittisi tallentuu reissun ajan. Lopeta reissu sovelluksessa, niin tallennus loppuu.",
  tripNoLocation: "ReelHunt ei saa käyttää sijaintia. Salli se puhelimen asetuksista (Sovellukset → ReelHunt → Luvat).",
  pushNativeSoon: "Ilmoitukset tulevat Android-sovellukseen pian. Sillä välin ne toimivat verkkosovelluksessa (reelhunt.fi/app Chromessa).",
  tripGo: "Aloita",
  tripStarted: "Reissu alkoi. Onnea matkaan!",
  tripEnd: "Lopeta",
  tripEndConfirm: "Lopetetaanko?",
  tripSpots: "Paikat",
  tripScreenOn: "Pidä näyttö päällä",
  tripCatches: (n) => n === 1 ? "1 saalis" : `${n} saalista`,
  durHm: (h, m) => `${h} t ${m} min`,
  durM: (m) => `${m} min`,
  spotsTitle: "Ehdotetut paikat",
  spotsFor: (name) => `Laji: ${name}. Aiempien saaliidesi ja tämän päivän sään perusteella.`,
  spotsLoading: "Etsitään paikkoja…",
  spotsNone: (name) => `Lajista ${name} ei ole vielä aiempia saaliita paikkatietoineen. Kirjaa saaliit tällä reissulla, niin ensi kerralla saat tähän ehdotuksia.`,
  spotsOffline: "Säätietoa ei nyt saatu: ehdotukset perustuvat vain vuodenaikaan ja kellonaikaan.",
  spotMatch: (p) => `${p} % osuma`,
  spotCatches: (n, when) => `${n === 1 ? "1 saalis" : `${n} saalista`} täältä, viimeisin ${when}`,
  spotShared: (who) => `mukana jakanut ${who}`,
  spotKm: (km) => `${km} km päässä`,
  spotShow: "Näytä",
  reason_season: "sama vuodenaika", reason_hour: "sama kellonaika", reason_wind: "samanlainen tuuli",
  reason_dir: "sama tuulen suunta", reason_trend: "sama ilmanpaineen suunta", reason_water: "samanlainen veden lämpötila",
  tripSummary: "Reissun yhteenveto",
  tripTime: "Aika",
  tripDistance: "Matka",
  tripCaught: "Saaliit",
  tripNoCatches: "Ei saalista tällä kertaa.",
  tripWeatherStart: "Sää alussa",
  tripSaveGpx: "Tallenna reitti (GPX)",
  tripShowMap: "Näytä kartalla",
  tripDelete: "Poista reissu",
  tripDeleted: "Reissu poistettu.",
  tripsTitle: "Reissusi",
  tripsNone: "Ei vielä reissuja. Aloita reissu kartalta.",

  // Tili ja pilvivarmuuskopio
  accountTitle: "Tili ja pilvivarmuuskopio",
  accountIntro: "Vapaaehtoinen. Kirjaudu sähköpostilla, niin saaliit, merkit ja porukat varmuuskopioituvat pilveen ja saat ne takaisin uuteen puhelimeen. Ei salasanaa: lähetämme koodin sähköpostiisi.",
  accountSignIn: "Kirjaudu",
  accountAs: (email) => `Kirjautuneena: ${email}`,
  accountNews: "Uutiset sähköpostiin",
  accountNewsText: "Silloin tällöin, uusista ominaisuuksista. Voit perua milloin vain.",
  accountSignOut: "Kirjaudu ulos",
  accountDelete: "Poista tili",
  accountDeleteConfirm: "Napauta uudelleen poistaaksesi",
  accountDeleted: "Tili ja pilvivarmuuskopio poistettu. Kaikki puhelimessa oleva säilyy.",
  signedOut: "Kirjauduttu ulos. Kaikki puhelimessa oleva säilyy.",
  signInTitle: "Kirjaudu",
  signInEmail: "Sähköposti",
  signInEmailPh: "sinä@esimerkki.fi",
  signInNews: "Saatte lähettää minulle ReelHunt-uutisia (vapaaehtoinen)",
  signInSendCode: "Lähetä koodi",
  signInCodeSent: (email) => `Lähetimme 6-numeroisen koodin osoitteeseen ${email}. Viestin tulo voi kestää hetken; katso myös roskapostikansio.`,
  signInCode: "Koodi",
  signInResend: "Lähetä uusi koodi",
  signInWait: (s) => `Voit pyytää uuden koodin ${s} sekunnin päästä.`,
  signInBadEmail: "Tarkista sähköpostiosoite.",
  signInWrongCode: (n) => `Väärä koodi. Yrityksiä jäljellä: ${n}.`,
  signInExpired: "Koodi on vanhentunut tai jo käytetty. Pyydä uusi.",
  signInTooMany: "Liian monta yritystä. Odota hetki ja yritä uudelleen.",
  signInUnavailable: "Kirjautuminen ei ole vielä käytössä. Yritä myöhemmin.",
  signInFailed: "Kirjautuminen ei onnistunut. Tarkista yhteys ja yritä uudelleen.",
  signedIn: "Kirjauduttu.",
  cloudLast: (when, c, p) => `Viimeisin pilvivarmuuskopio ${when}: ${c} saalista, ${p} merkkiä.`,
  cloudNone: "Ei vielä pilvivarmuuskopiota.",
  cloudAuto: "Varmuuskopioituu itsestään noin kerran päivässä, kun jotain on muuttunut. Kuvista tallentuvat pienet esikatselukuvat; täysikokoiset kuvat saat talteen varmuuskopiotiedostoon.",
  cloudNow: "Varmuuskopioi nyt",
  cloudRestore: "Palauta pilvestä",
  cloudRestoreConfirm: "Napauta uudelleen palauttaaksesi",
  cloudBackingUp: "Varmuuskopioidaan…",
  cloudDone: "Varmuuskopioitu pilveen.",
  cloudFailed: "Pilvivarmuuskopio epäonnistui. Tarkista yhteys.",
  cloudRestored: (n) => `Palautettiin ${n} saalista pilvestä. Kaikki puhelimessa jo ollut säilyi.`,
  cloudRestoreFailed: "Palautus ei onnistunut. Tarkista yhteys.",
  cloudOfferTitle: "Sinulla on pilvivarmuuskopio",
  cloudOffer: (c, p) => `Siinä on ${c} saalista ja ${p} merkkiä. Palautetaanko ne tähän puhelimeen?`,
  cloudOfferYes: "Palauta",

  usageTitle: "Nimettömät käyttötilastot",
  usageText: "Sovellus kertoo kerran päivässä olevansa käytössä, mukana muutama lukumäärä (esim. saaliiden ja porukoiden määrä). Ei mitään sinusta, ei paikkoja, ei porukoiden tietoja. Näin näemme, kuinka moni ReelHuntia käyttää.",

  // ReelHunt Plus ja seurapaketti (billing.ts, paywall.ts)
  plusName: "ReelHunt Plus", plusBadge: "Plus",
  payPlusLead: "Opi omista saaliistasi: milloin, missä ja millä säällä syö.",
  payWelcomeBack: "Saaliisi ovat kaikki tallessa. Plus tuo lisäominaisuudet takaisin:",
  payBenefitBest: "Parhaat olosuhteesi: kellonaika, tuuli ja ilmanpaine, joilla saat kunkin lajin",
  payBenefitTip: "Vinkki, kun tuleva sää vastaa parhaita saaliitasi, myös iltailmoituksena",
  payBenefitSpots: "Ehdotetut paikat retkillä omista ja kavereiden jakamista saaliista",
  payBenefitSeason: "Kauden kooste: vuotesi tarinana, myös porukallesi",
  payBenefitPhotos: "Täysikokoiset kuvat pilvivarmuuskopioon (tulossa myöhemmin)",
  payFreeNote: "Saaliiden kirjaus, sää, kartta ja porukat pysyvät ilmaisina. Kaikki kirjaamasi on aina sinun: voit katsoa ja viedä sen ulos.",
  payNoAds: "Ei mainoksia. Emme koskaan myy tietojasi.",
  payYear: "Vuosi", payMonth: "Kuukausi", unitYear: "vuosi", unitMonth: "kk",
  payAboutMonth: (p) => `n. ${p} / kk`, paySave: (n) => `säästä ${n} %`,
  payFoundingBadge: "Perustajajäsenen hinta",
  payFounding: "Perustajajäsenen hinta: pidät sen niin kauan kuin tilauksesi jatkuu.",
  payFirstFree: "Ensimmäinen kuukausi ilmaiseksi",
  payTrialBtn: "Kokeile ilmaiseksi kuukausi", payBuyBtn: "Tilaa",
  payThenPrice: (p, u) => `Ensimmäinen kuukausi ilmaiseksi, sen jälkeen ${p} / ${u}.`,
  payCharged: (p, u, store) => `${p} / ${u}, maksu ${store} -kaupan kautta.`,
  payAutoRenew: (store) => `Tilaus jatkuu automaattisesti, kunnes perut sen. Voit perua milloin tahansa ${store} -kaupan tilauksista viimeistään 24 tuntia ennen jakson loppua.`,
  payTrialCancel: "Ilmaisen kuukauden aikana peruminen ei maksa mitään.",
  payRestore: "Palauta ostokset", payRestored: "Ostokset palautettu.", payNothingToRestore: "Tällä kauppatilillä ei löytynyt ostoksia.",
  payTerms: "Käyttöehdot",
  payLoading: "Haetaan hintoja…",
  payNoStore: "Kauppaan ei saada nyt yhteyttä. Tarkista verkkoyhteys ja yritä uudelleen.",
  payBuyInApp: "Plus ja seurapaketti ostetaan ReelHunt-sovelluksessa (Google Play tai App Store). Kirjaudu samalla sähköpostilla sovelluksessa ja täällä, niin ne toimivat myös verkkosivulla.",
  payPending: "Osto on vielä kesken. Jos maksu vahvistuu myöhemmin, tilaus tulee voimaan itsestään.",
  payNotAllowed: "Ostot on estetty tässä laitteessa (esim. lapsilukko).",
  payOffline: "Ei yhteyttä. Tarkista verkkoyhteys ja yritä uudelleen.",
  payFailed: "Osto ei onnistunut. Yritä hetken päästä uudelleen.",
  payRestoreFailed: "Palautus ei onnistunut. Tarkista verkkoyhteys ja että olet kirjautunut samaan Google- tai Apple-tiliin.",
  payThanks: "Kiitos! Plus on käytössä.", payThanksTrial: "Ilmainen kuukausi alkoi. Hyviä saaliita!",
  payWhyBest: "Parhaat olosuhteesi kuuluvat ReelHunt Plussaan.",
  payWhySpots: "Ehdotetut paikat kuuluvat ReelHunt Plussaan.",
  payWhySeason: "Kauden kooste kuuluu ReelHunt Plussaan.",
  // seurapaketti
  payClubTitle: "Seurapaketti",
  payClubLead: (g) => `Täysi passitaulu porukalle ${g}. Yksi jäsen maksaa, koko porukka käyttää.`,
  payClubB1: (n) => `Niin monta passia kuin seuralla on (ilman pakettia ${n})`,
  payClubB2: "Passiarvonta jokaiselle metsästyspäivälle",
  payClubB3: "Kaikille porukan jäsenille, myös myöhemmin liittyville",
  payClubNote: "Jo lisätyt passit ja varaukset näkyvät aina.",
  payClubBtn: "Osta seuralle",
  payClubCharged: (p, store) => `${p} / vuosi, maksat ${store} -kaupan kautta. Kattaa yhden porukan.`,
  payClubThanks: (g) => `Passitaulu on avattu porukalle ${g}.`,
  payClubAlready: "Toinen jäsen on jo avannut tämän porukan passitaulun.",
  payClubMove: "Käytä seurapakettiani tässä",
  payClubMoveNote: "Seurapakettisi kattaa yhden porukan. Jos siirrät sen tänne, toisen porukan taulun lisäominaisuudet sulkeutuvat (passit säilyvät).",
  payClubClaimFailed: "Seurapakettia ei saatu liitettyä tähän porukkaan. Tarkista verkkoyhteys ja yritä uudelleen.",
  payWhyStands: (n) => `Ilman seurapakettia tauluun mahtuu ${n} passia.`,
  payWhyDraw: "Passiarvonta kuuluu seurapakettiin.",
  clubPlanOn: "Seurapaketti käytössä", clubFreeCount: (n, max) => `${n} / ${max} passia ilman seurapakettia`,
  clubUnlock: "Hanki seurapaketti",
  // houkuttimet
  learnPlusText: (names) => `ReelHunt on oppinut saaliistasi (${names}), milloin ja millä säällä niitä saat. Näet sen Plussalla.`,
  spotsPlusText: "Plussalla retki ehdottaa paikkoja aiemmista saaliistasi ja kavereiden jakamista saaliista, jotka vastaavat tämän päivän säätä.",
  plusTry: "Kokeile ilmaiseksi", plusSee: "Katso Plus",
  // Plus-paneeli Asetuksissa
  plusOff: "Plus-ominaisuudet ovat kaikille ilmaisia ReelHuntin testivaiheen ajan.",
  plusNone: "Käytät ilmaisversiota. Plus tuo parhaat olosuhteesi, niihin sopivat säävinkit, ehdotetut paikat ja kauden koosteen.",
  plusTrial: (d) => `Ilmainen kuukausi ${d} asti.`,
  plusTrialThen: "Sen jälkeen tilaus jatkuu maksullisena, ellet peru sitä.",
  plusActive: (plan) => `Plus käytössä · ${plan}`,
  plusRenews: (d) => `Uusiutuu ${d}.`, plusEnds: (d) => `Päättyy ${d}, ei uusiudu.`,
  plusExpired: (d) => `Plus päättyi ${d}. Kaikki kirjaamasi on edelleen tallessa.`,
  plusBillingIssue: "Kauppa ei saanut veloitettua maksua. Tarkista maksutapasi kaupassa.",
  plusManage: "Hallitse tilausta",
  plusClubOn: (d) => `Seurapaketti käytössä ${d} asti. Se kattaa porukan, jolle ostit sen.`,
  plusClubEnded: (d) => `Seurapaketti päättyi ${d}.`,
  plusTest: "Testitila (simuloitu kauppa)", plusTestOffer: "Perustajatarjous", plusTestClub: "Oma seurapaketti",
  plusTest_none: "Ilmainen", plusTest_trial: "Ilmainen kk", plusTest_active: "Tilattu", plusTest_expired: "Kokeilu päättyi", plusTest_lapsed: "Päättynyt", plusTest_restore: "Ostettu, ei palautettu",
  // Suojassa tuulelta (trip/shelter-ui.ts)
  shelterBtn: "Tuulensuojaiset paikat", shelterTitle: "Suojassa tuulelta",
  shelterNight: "Verkko yöksi", shelterNow: "Kalastus nyt",
  shelterLoading: "Haetaan sijaintia ja ennustetta…", shelterLoadingShores: "Etsitään lähirantoja…",
  shelterOffline: "Tähän tarvitaan verkkoyhteys.", shelterFailed: "Ennuste tai karttatiedot eivät latautuneet. Yritä hetken päästä.",
  shelterNoForecast: "Tuuliennuste ei latautunut. Tarkista verkkoyhteys ja yritä uudelleen.",
  shelterNoMap: "Rantojen karttatiedot eivät latautuneet. Tarkista verkkoyhteys ja yritä uudelleen.",
  shelterWind: (from, s) => `Tuuli ${from}, ${s} m/s`,
  shelterWindThen: (time, from, s) => `klo ${time} alkaen ${from}, ${s} m/s`,
  shelterGusts: (g) => `Puuskat enintään ${g} m/s.`,
  shelterGustWarn: (g) => `Puuskat jopa ${g} m/s: verkot voivat kärsiä suojaisissakin paikoissa. Harkitse nostamista.`,
  shelterCalm: "Heikkoa tuulta: lähes mikä paikka tahansa käy.",
  shelterNone: (km) => `${km} km:n säteellä ei löytynyt rantoja. Siirry lähemmäs vettä tai valitse pidempi etäisyys.`,
  shelterRange: "Etäisyys",
  shelterHistory: (n) => n === 1 ? "1 saalis tästä aiemmin" : `${n} saalista tästä aiemmin`,
  shelterHistoryShared: (n, f) => `${n} saalista tästä aiemmin (${f} kavereilta)`, shelterClear: "Poista kartalta", shelterKmOpt: (km) => `${km} km`,
  shelterPfLabel: "Tuulensuojaiset paikat: kuinka kaukaa etsitään", shelterPfHint: "2 km rannalta, 10 km veneellä. Voit vaihtaa sen myös haussa.",
  shelterLevel_good: "Suojaisa", shelterLevel_ok: "Melko suojaisa", shelterLevel_rough: "Tuulinen",
  shelterFetch: (d) => `Tuulen puolella ${d} avovettä`, shelterFetchNone: "Aivan rannan suojassa",
  shelterWorst: (time, s, from) => `Tuulisinta klo ${time}: ${s} m/s ${from}`,
  shelterInWind: (from, level) => `${from}: ${level}`,
  shelterNote: "Rannat © OpenStreetMap-tekijät (OpenFreeMap). Tarkista syvyys, säännöt, luvat ja rannan omistajan oikeudet itse.",
  shelterPlusText: "Plussalla ReelHunt etsii lähirannat, joihin tuleva tuuli ei nosta aaltoja: verkolle yöksi tai kalastukseen nyt.",
  payWhyShelter: "Tuulensuojaiset paikat kuuluvat ReelHunt Plussaan.",
  payBenefitShelter: "Tuulensuojaiset paikat verkolle yöksi tai kalastukseen nyt tulevan tuulen mukaan",
  // Lists
  compass: ["P", "KO", "I", "KA", "E", "LO", "L", "LU"],
  windNames: ["pohjoistuuli", "koillistuuli", "itätuuli", "kaakkoistuuli", "etelätuuli", "lounaistuuli", "länsituuli", "luoteistuuli"],
  dirFrom: ["pohjoisesta", "koillisesta", "idästä", "kaakosta", "etelästä", "lounaasta", "lännestä", "luoteesta"],
  dirTo: ["pohjoiseen", "koilliseen", "itään", "kaakkoon", "etelään", "lounaaseen", "länteen", "luoteeseen"],
  moonPhases: ["Uusikuu", "Kasvava sirppi", "Ensimmäinen neljännes", "Kasvava kuu", "Täysikuu", "Vähenevä kuu", "Viimeinen neljännes", "Vähenevä sirppi"],
  wmo: { 0: "Selkeää", 1: "Enimmäkseen selkeää", 2: "Puolipilvistä", 3: "Pilvistä", 45: "Sumua", 48: "Huurtavaa sumua",
    51: "Heikkoa tihkua", 53: "Tihkusadetta", 55: "Voimakasta tihkua", 56: "Jäätävää tihkua", 57: "Jäätävää tihkua",
    61: "Heikkoa sadetta", 63: "Sadetta", 65: "Voimakasta sadetta", 66: "Jäätävää sadetta", 67: "Jäätävää sadetta",
    71: "Heikkoa lumisadetta", 73: "Lumisadetta", 75: "Voimakasta lumisadetta", 77: "Lumijyväsiä", 80: "Heikkoja sadekuuroja",
    81: "Sadekuuroja", 82: "Voimakkaita sadekuuroja", 85: "Lumikuuroja", 86: "Voimakkaita lumikuuroja",
    95: "Ukkosta", 96: "Ukkosta ja raetta", 99: "Ukkosta ja raetta" },
  methods: { lure: "Uistin", jig: "Jigi", fly: "Perho", bait: "Syötti", trolling: "Vetouistelu", ice: "Pilkki", net: "Verkko",
    rifle: "Kivääri", shotgun: "Haulikko", bow: "Jousi", trap: "Loukku", longline: "Pitkäsiima", trapnet: "Katiska / rysä" },
  species: {
    perch: "Ahven", pike: "Hauki", zander: "Kuha", browntrout: "Taimen", rainbowtrout: "Kirjolohi",
    grayling: "Harjus", whitefish: "Siika", salmon: "Lohi", char: "Nieriä", bream: "Lahna", burbot: "Made",
    ide: "Säyne", roach: "Särki", vendace: "Muikku", asp: "Toutain", tench: "Suutari", seatrout: "Meritaimen",
    moose: "Hirvi", whitetail: "Valkohäntäpeura", roedeer: "Metsäkauris", fallowdeer: "Kuusipeura", boar: "Villisika",
    mountainhare: "Metsäjänis", brownhare: "Rusakko", fox: "Kettu", raccoondog: "Supikoira",
    capercaillie: "Metso", blackgrouse: "Teeri", hazelgrouse: "Pyy", willowgrouse: "Riekko",
    mallard: "Sinisorsa", teal: "Tavi", goldeneye: "Telkkä", wigeon: "Haapana", canadagoose: "Kanadanhanhi",
    greylag: "Merihanhi", woodpigeon: "Sepelkyyhky", pheasant: "Fasaani", beaver: "Majava", woodcock: "Lehtokurppa",
  },
};
